import { CSSProperties, MouseEventHandler, ReactNode, RefObject } from "react";

import styles from "./button.module.css";

type Props = {
  children: ReactNode;
  type: "primary" | "default" | "ghost" | "secondary";
  onClick?: MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
  size?: "s";
  style?: CSSProperties;
  className?: string;
  disabled?: boolean;
  as?: "div" | "button";
};

export const Button = ({
  children,
  type,
  onClick,
  size,
  style,
  className = "",
  disabled,
  as = "button",
}: Props) => {
  const Component = as;

  return (
    <Component
      className={`${styles.button} ${styles[type]} ${size ? styles[size] : ""} ${className}`}
      style={style}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Component>
  );
};
